import React, { useEffect, useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import en from '../static/img/en.png';
import ja from '../static/img/ja.png';
import fr from '../static/img/fr.png';
import alibaba from '../static/img/alibabacloud.svg';
import aws from '../static/img/aws.svg';
import { useMediaQuery } from 'react-responsive';
import Grid from '@material-ui/core/Grid';
const langsEn = [
	{ name: 'Japanese', img: ja, level: 'native language' },
	{ name: 'English', img: en, level: 'full professional proficiency' },
	{ name: 'French', img: fr, level: 'limited working proficiency' }
];

const langsJa = [
	{ name: '日本語', img: ja, level: '母国語' },
	{ name: '英語', img: en, level: 'ビジネスレベル' },
	{ name: 'フランス語', img: fr, level: '日常会話レベル' }
];

const sectionTitle = { en: 'Language', ja: '言語' };

const LanguageLevel = ({ language }) => {
	const [ langs, setLangs ] = useState([]);
	useEffect(
		() => {
			language == 'English' ? setLangs(langsEn) : setLangs(langsJa);
		},
		[ language ]
	);
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

	return (
		<div className="language">
			<h2 className="mb-0 text-center sectionTitle" style={{ paddingTop: '10rem' }}>
				{language == 'English' ? sectionTitle.en : sectionTitle.ja}
			</h2>
			<List className="text-center mx-auto" style={{width:'60%'}}>
			<Grid container>
				{langs.map((lang, i) => (
					<Grid item sm={12} md={4} key={i}>
						<ListItem>
						<ListItemAvatar>
							<Avatar alt={lang.name} src={lang.img} />
						</ListItemAvatar>
						<ListItemText primary={lang.name} secondary={lang.level} />
					</ListItem>
						</Grid>
					
				))}
				</Grid>
			</List>
			<h3 className="text-center mb-3" style={{ marginTop: '5rem' }}>
				{language == 'English' ?'Translation Experience (Freelance)':'翻訳経験(フリーランス )'}
			</h3>
			<div className="text-center mx-auto mt-3" style={{width:'60%'}} >
				<Grid container spacing={5} className="p-3">
					<Grid item md={4} sm={12} className="text-left py-1">
						<h4 className="mb-1">
							<strong>{language == 'English' ? 'AWS SME Review' : 'AWS専門家レビュー'}</strong>
						</h4>
						<h5 className="mb-1">
							{language == 'English' ? 'AWS Solution Architect examination' : 'AWS ソリューションアーキテクト試験'}
						</h5>
						<small>({language == 'English' ? 'English to Japanese' : '英日'})</small>
						<p>{language == 'English' ? '2019 Oct - 2019 Nov' : '2019年10月 - 2019年11月'}</p>
					</Grid>
					<Grid item md={4} sm={12} className="text-left py-1">
						<h4 className="mb-1">
							<strong>{language == 'English' ? 'Alibaba Cloud Translation' : 'アリババクラウド翻訳'}</strong>
						</h4>
						<h5 className="mb-1">{language == 'English' ? 'User Guide' : 'ユーザーガイド'}</h5>
						<small>({language == 'English' ? 'English to Japanese' : '英日'})</small>
						<p>{language == 'English' ? '2018 July- 2018 Sep' : '2018年7月 - 2018年9月'}</p>
						</Grid>
					<Grid item md={4} sm={12} className="text-left py-1">
						<h4 className="mb-1">{language == 'English' ? 'Others' : 'その他'}</h4>
						<h5 className="mb-1">
							{language == 'English' ? (
								'Localization for Web Application, Mobile game etc'
							) : (
								'ウェブアプリケーション、モバイルゲームなどのローカライゼーション'
							)}
						</h5>
						<small>({language == 'English' ? 'Entglish, Japanese, French' : '英日, 日英, 仏日, 日仏'})</small>
						<p>{language == 'English' ? '2016 - Present' : '2016年 - 現在'}</p>
						</Grid>
				</Grid>
			</div>
		</div>
	);
};
export default LanguageLevel;
